import numbro from 'numbro';
import isNaNLodash from 'lodash/isNaN';
import { ONE_MEGABYTE } from '@constants/resource';

export const getNumbroFormatOptions = (value: string | number) => ({
  output: 'byte',
  base: 'binary',
  mantissa: Number(value) > ONE_MEGABYTE ? 2 : 0,
  spaceSeparated: true,
});

/**
 * Formats byte size to a human readable value in Kb or other units
 * @param {number} size Size to format
 */
export const formatSize = (size: number): string => {
  if (size === undefined || size === null) {
    return '';
  }
  const numbroFormatOptions = getNumbroFormatOptions(size);
  return numbro(size)
    .format(numbroFormatOptions as any)
    .replace('i', '');
};

/**
 * Shorthand for determing max system upload size based on environment
 * variable or fallback
 * @returns {number} Max upload size in bytes
 */
export const getMaxUploadSize = () => {
  const MAX_UPLOAD_SIZE_FALLBACK_BYTES = 1000000000;
  const maxSize = isNaNLodash(
    Number(import.meta.env.VITE_MAX_UPLOAD_SIZE_BYTES),
  )
    ? MAX_UPLOAD_SIZE_FALLBACK_BYTES
    : Number(import.meta.env.VITE_MAX_UPLOAD_SIZE_BYTES);
  return maxSize;
};
